__turbopack_context__.v({
  "famousFrom": "utXkpa_famousFrom",
  "insurances": "utXkpa_insurances",
  "logoCarouselFamousFrom": "utXkpa_logoCarouselFamousFrom",
  "logoSvg": "utXkpa_logoSvg",
  "logos": "utXkpa_logos",
  "logosScrollable": "utXkpa_logosScrollable",
  "threeLineEllipse": "utXkpa_threeLineEllipse",
});
